import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';

import { DeleteClientPortalUserInput, DeleteClientPortalUserPayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MUTATION_CLIENT_PORTAL_USER_RELATION_DELETE = gql`
mutation deleteClientPortalUserRelationship($input:DeleteClientPortalUserInput!){
  deleteClientPortalUserRelationship(input:$input){
    message
    result
    tenantId
    portalUserId
  }
}
`;

export const mutationDeleteClientPortalUserRelation = async (
  client: ApolloClient<NormalizedCacheObject>,
  args: {
    clientTenantId: string,
    portalUserId: string,
  }
): Promise<DeleteClientPortalUserPayload | undefined> => {
  const { clientTenantId, portalUserId } = args;
  const { data, errors } = await client.mutate<{ deleteClientPortalUserRelationship: DeleteClientPortalUserPayload }>({
    variables: {
      input: {
        tenantId: clientTenantId, 
        portalUserId
      }
    },
    mutation: MUTATION_CLIENT_PORTAL_USER_RELATION_DELETE
  });
  if (errors && errors.length > 0) {
    errors.forEach(error => {
      // Log error details in the console.
      console.error(error);
    });
    // Friendly error to the person.
    throw new Error('An error has occurred during the removal of the Portal User from the Client.');
  }
  if (data && data.deleteClientPortalUserRelationship) {
    return data.deleteClientPortalUserRelationship;
  }

  return undefined;
};